import jwtDecode from 'jwt-decode';

const TOKEN_KEY = 'csg.at';

const TokenService = {
  getToken() {
    return getCookie(TOKEN_KEY);
  },

  removeToken() {
    deleteCookie(TOKEN_KEY);
  },

  decode(token) {
    if (!token) {
      return null;
    }
    return jwtDecode(token);
  },
  isExpired(token) {
    if (!token) {
      return null;
    }
    const decoded = jwtDecode(token);
    const now = new Date().getTime();
    return decoded.exp * 1000 < now;
  },
};

export default TokenService;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return parts
      .pop()
      .split(';')
      .shift();
}

function deleteCookie(name) {
  document.cookie = name + '=;Domain=.casago.com; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  document.cookie = name + '=;Domain=.casago.com; Secure; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  document.cookie = name + '=; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
